import React from 'react'
import { projectData as PData } from '../../../data/projects.data';

import logoConstructora from './../../../UI/Logos/logo-constructora.svg'
import collapseBtn from './../../../UI/icons/Sidebar/arrow.svg'
import Icons from '../../../utils/import.icons';
import Back from './../../../UI/icons/Sidebar/back-btn.svg'


interface Props{
    isCollapsed: boolean,
    handleCollapseMenu: any,
    handleChangeProject: any,
    handleSidebarClick: any,
    sidebarBtnSelected: any,
    handleBackBtn: any
}

interface State{
    projectData: any,
    currentSelectedProject: any
}

class Sidebar extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            projectData: PData,
            currentSelectedProject: 0
        }
    }

    handleSelectProject = (index: number, name: string) => {
        this.setState({
            currentSelectedProject: index
        }, () => {
            this.props.handleChangeProject(name)
        })
    }

    handleGenerateStructure = () => {
        return(
            this.state.projectData.Projects.map((project, index) => 
                <div className={this.props.isCollapsed ? 'general-container fade-out': this.state.currentSelectedProject === index ? 'general-container-selected fade-in':'general-container fade-in'} key={index}>
                    <div className={this.state.currentSelectedProject === index ? 'project-individual-container-selected':'project-individual-container'} onClick={() => {this.handleSelectProject(index, project.Slug)}}>
                        <img src={this.state.currentSelectedProject === index ? project.IconoSelected.default:project.Icono.default}/>
                        <div>{project.Nombre}</div> 
                    </div>
                    {
                        this.state.currentSelectedProject === index && project.Modules ? 
                        <div className='masterplan-container'>
                            {
                                project.Modules.map((module, indexModule) =>
                                <div className={this.props.sidebarBtnSelected === module.Name ? 'btn-selected-masterplan-main-selected':'btn-selected-masterplan-main'}
                                    onClick={() => {this.props.handleSidebarClick(module.Name)}}
                                >
                                    <img src={this.props.sidebarBtnSelected === module.Name ? Icons[module.slug + "2"]:Icons[module.slug]}/>
                                    <div>{module.Name}</div>
                                </div>
                                )
                            }
                        </div>: null
                    }
                    {
                        this.state.currentSelectedProject === index && project.Modules && this.props.sidebarBtnSelected !== "" ?
                        <div className='back-btn' onClick={() => {this.props.handleBackBtn()}}>
                            <img src={Back}/>
                        </div>:null
                    }
                </div>
            )
        )
    }

    render(): React.ReactNode {
        return(
            <div className='sidebar'>
                <div className='header-logo'>
                    <img src={logoConstructora}/>
                </div>
                <div className={this.props.isCollapsed ? "sidebar-content-collapsed":"sidebar-content"}>
                    {
                        this.handleGenerateStructure()
                    }
                </div>
                <div className={this.props.isCollapsed ? 'collapse-btn-collapsed':'collapse-btn'} onClick={() => {this.props.handleCollapseMenu()}}>
                    <img src={collapseBtn}/>
                </div>
            </div>
        )
    }
}

export default Sidebar